import { useCentralApi, useCurrentUser } from "hooks/shared";
import { ISelectItem } from "models/common";
import { useEffect, useState } from "react";

type UseWorkItemWorkspacesResult = [
    ISelectItem[],
    boolean
];

type UseWorkItemWorkspacesSignature = (id: number, draft?: boolean) => UseWorkItemWorkspacesResult;

const useWorkItemWorkspaces: UseWorkItemWorkspacesSignature = (id: number, draft: boolean = false) => {
    const [ data, setData ] = useState<ISelectItem[]>([]);
    const [ loading, setLoading ] = useState<boolean>(true);

    const user = useCurrentUser();
    const fetcher = useCentralApi(user);

    useEffect(() => {
        if (id === 0) return;
        if (!user || !user.access_token) return;

        const controller = new AbortController();
        (async () => {
            setLoading(true);
            try {
                const url = `/api/v3/workitems/${id}/workspaces?draft=${draft}`;
                const resp = await fetcher(url, {
                    signal: controller.signal
                });

                const result = await resp.json() as ISelectItem[];
                setData(result);
            } finally {
                if (!controller.signal.aborted)
                    setLoading(false);
            }
        })();

        return () => {
            controller.abort();
        }
    }, [ id, user ]);

    return [
        data,
        loading
    ];
};

export default useWorkItemWorkspaces;